import { render, staticRenderFns } from "./TenantNotificationTranslate.vue?vue&type=template&id=30100e9a"
import script from "./TenantNotificationTranslate.vue?vue&type=script&lang=js"
export * from "./TenantNotificationTranslate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports